import "./module/userAgentChecker.js"
import "./module/picturefill.js"
import "./module/plugin.js"

import Swiper from 'swiper/bundle';
var mySwiper = new Swiper('.mv__slider', {
    slidesPerView: 'auto',
    centeredSlides: true,
    speed: 2500,
    loop: true,
    autoplay: {
        delay: 4500,
        disableOnInteraction: false,
    },
});

var mySwiper01 = new Swiper('.insta__innerSliderContainer', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    speed: 1800,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 50
        }
    }
});

var mySwiper02 = new Swiper('.reccomend__innerBlockSliderContainer', {
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    speed: 1800,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        768: {
            slidesPerView: 3,
            spaceBetween: 50
        }
    }
});

var mySwiper03 = new Swiper('.intro__slider', {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,
  speed: 1800,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

var mySwiper04 = new Swiper('.hassou__innerSlider', {
  slidesPerView: 1,
  spaceBetween: 50,
  loop: true,
  speed: 6000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
        slidesPerView: 3
    }
}
});

var $ = require('jquery');


const target = document.getElementById('lineBnr');
const button = document.getElementById('lineBtn');
const key = 'class';
const value = 'change';
const data = sessionStorage.getItem(key);

if (target && button) {
  if (data) {
    target.classList.add(value);
  }

  button.addEventListener('click', () => {
    target.classList.toggle(value);

    if (target.classList.contains(value)) {
      sessionStorage.setItem(key, value);
    } else {
      sessionStorage.removeItem(key);
    }
  });
}

require('picturefill');